import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { PlanServiceChargeData } from "config/tableConfigs";
import PlanServiceChargeFormModal from "./components/PlanServiceChargeFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const PlanServiceChargePage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/plan_service_charge_action",
    PlanServiceChargeData,
    formdata,
    refresh
  );

  const handleAddUser  = () => { setModalMode("add"); setSelectedUser(null); setModalShow(true); };
  const handleEditUser = (user) => { setModalMode("edit"); setSelectedUser(user); setModalShow(true); };
  const handleDelete   = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const el = document.getElementById("deletePlanServiceCharge");
      if (el) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }, 100);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Custom Header Layout */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Plan Service Charges</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-list-dashes f-s-16"></i> <span className="ms-1">Plan</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Service Charges
                </a>
              </div>
            </div>

            <div>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center px-4"
                onClick={handleAddUser}
                style={{
                  backgroundColor: "#7e57c2", borderColor: "#7e57c2", borderRadius: "8px", height: "44px", width: "fit-content", minWidth: "160px"
                }}
              >
                <i className="iconoir-plus-circle me-2" style={{ fontSize: "20px" }}></i>
                <span className="fw-medium text-nowrap">Add Service Charge</span>
              </button>
            </div>
          </div>
        </div>

        {/* Card Body */}
        <div className="row m-1">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <DataTable
                  config={PlanServiceChargeData}
                  tableData={tableData}
                  onEdit={handleEditUser}
                  onDelete={handleDelete}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <PlanServiceChargeFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={() => { setRefresh(p => p + 1); setModalShow(false); }}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deletePlanServiceCharge"
        title="Delete Service Charge"
        message="Are you sure you want to delete this service charge?"
        apiUrl="https://pro.mokshiq.in/plan_service_charge_action"
        onSuccess={() => setRefresh(p => p + 1)}
      />
    </main>
  );
};

export default PlanServiceChargePage;